export const emptyFolderText = "cP3upc";
export default {emptyFolderText};